import React, { useState, useEffect } from 'react';
import { api } from '../api';
import { Modal, LabelPreview, StepBanner } from '../components/UI';

const TIPOS = [
  { v: 'TOM', l: 'Tomates' }, { v: 'CEB', l: 'Cebolla' }, { v: 'AJO', l: 'Ajo' },
  { v: 'ACE', l: 'Aceite' }, { v: 'HAR', l: 'Harina' }, { v: 'AZU', l: 'Azúcar' },
  { v: 'SAL', l: 'Sal' }, { v: 'PIM', l: 'Pimentón' }, { v: 'LEG', l: 'Legumbres' },
];

const SAP_OCS = [
  { oc: '4500123456', material: 'Tomates frescos', qty: '500', unidad: 'kg', proveedor: 'Agrícola Sur SPA', tipo: 'TOM', desc: 'frescos', fecha: '18 mar 2026' },
  { oc: '4500123460', material: 'Aceite oliva virgen extra', qty: '100', unidad: 'lt', proveedor: 'Olicor Ltda', tipo: 'ACE', desc: 'virgen extra', fecha: '19 mar 2026' },
  { oc: '4500123471', material: 'Harina trigo 000', qty: '200', unidad: 'kg', proveedor: 'Molino Central SA', tipo: 'HAR', desc: 'trigo 000', fecha: '19 mar 2026' },
];

export default function Recepcion({ showNotif }) {
  const [tab, setTab] = useState('manual');
  const [recepciones, setRecepciones] = useState([]);
  const [search, setSearch] = useState('');
  const [form, setForm] = useState({ tipo: '', desc: '', qty: '', unidad: 'kg', vence: '', proveedor: '', guia: '', condicion: 'ok' });
  const [lotePreview, setLotePreview] = useState('');
  const [etiqueta, setEtiqueta] = useState(null);

  const load = async () => {
    const data = await api.getRecepciones(search);
    setRecepciones(data);
  };

  useEffect(() => { load(); }, [search]);

  const updateTipo = async (tipo) => {
    setForm(f => ({ ...f, tipo }));
    if (tipo) {
      const { lote } = await api.previewLote(tipo);
      setLotePreview(lote);
    } else {
      setLotePreview('');
    }
  };

  const registrar = async () => {
    if (!form.tipo || !form.qty) { showNotif('Completa tipo de producto y cantidad'); return; }
    try {
      await api.crearRecepcion({ ...form, lotePreview });
      showNotif('Recepción registrada · Lote ' + lotePreview);
      setForm({ tipo: '', desc: '', qty: '', unidad: 'kg', vence: '', proveedor: '', guia: '', condicion: 'ok' });
      setLotePreview('');
      load();
    } catch (e) { showNotif('Error: ' + e.message); }
  };

  const importarOC = (oc) => {
    setForm(f => ({ ...f, tipo: oc.tipo, desc: oc.desc, qty: oc.qty, unidad: oc.unidad, proveedor: oc.proveedor, guia: oc.oc }));
    updateTipo(oc.tipo);
    setTab('manual');
    showNotif('OC importada desde SAP · Completa y confirma');
  };

  const condBadge = (c) => c === 'ok'
    ? <span className="badge badge-green">✓ Conforme</span>
    : c === 'obs' ? <span className="badge badge-amber">⚠ Con obs.</span>
    : <span className="badge badge-red">✗ Rechazado</span>;

  return (
    <>
      <div className="topbar">
        <div>
          <div className="topbar-title">Recepción de materia prima</div>
          <div className="topbar-meta">Registra el ingreso de productos desde el proveedor</div>
        </div>
        <div className="topbar-actions">
          <button className="btn btn-ghost btn-sm" onClick={() => { setTab('sap'); showNotif('SAP S/4HANA: 3 OC cargadas'); }}>↻ Importar desde SAP</button>
          <button className="btn btn-primary btn-sm" onClick={() => setTab('manual')}>+ Nueva recepción</button>
        </div>
      </div>
      <StepBanner
        step={1} title="Recepción MP"
        desc="Registra cada vez que llega materia prima del proveedor. El sistema genera automáticamente un código de lote único para trazabilidad."
        next="Lotes en bodega"
      />
      <div className="page-content">
        <div className="tabs">
          {['manual', 'sap'].map(t => (
            <button key={t} className={`tab-btn ${tab === t ? 'active' : ''}`} onClick={() => setTab(t)}>
              {t === 'manual' ? 'Registro manual' : 'Importados desde SAP'}
            </button>
          ))}
        </div>

        {tab === 'manual' && (
          <>
            <div className="card" style={{ marginBottom: 18 }}>
              <div className="card-title"><div className="ct-icon">⊕</div> Registrar nueva recepción</div>
              <div className="form-section">
                <div className="form-section-title">Información del producto</div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Tipo de producto *</label>
                    <select value={form.tipo} onChange={e => updateTipo(e.target.value)}>
                      <option value="">Seleccionar tipo...</option>
                      {TIPOS.map(t => <option key={t.v} value={t.v}>{t.l}</option>)}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Variedad / descripción</label>
                    <input value={form.desc} onChange={e => setForm(f => ({ ...f, desc: e.target.value }))} placeholder="Ej: cherry, blanca, refinada..." />
                  </div>
                </div>
                <div className="form-row form-row-4">
                  <div className="form-group">
                    <label>Cantidad *</label>
                    <input type="number" value={form.qty} onChange={e => setForm(f => ({ ...f, qty: e.target.value }))} placeholder="0" min="0" />
                  </div>
                  <div className="form-group">
                    <label>Unidad</label>
                    <select value={form.unidad} onChange={e => setForm(f => ({ ...f, unidad: e.target.value }))}>
                      {['kg', 'lt', 'unid', 'cajas', 'sacos'].map(u => <option key={u}>{u}</option>)}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Fecha ingreso</label>
                    <input type="date" defaultValue="2026-03-20" />
                  </div>
                  <div className="form-group">
                    <label>Fecha vencimiento</label>
                    <input type="date" value={form.vence} onChange={e => setForm(f => ({ ...f, vence: e.target.value }))} />
                  </div>
                </div>
              </div>
              <div className="form-section">
                <div className="form-section-title">Proveedor y documento</div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Proveedor</label>
                    <input value={form.proveedor} onChange={e => setForm(f => ({ ...f, proveedor: e.target.value }))} placeholder="Nombre del proveedor" />
                  </div>
                  <div className="form-group">
                    <label>N° Guía / OC SAP</label>
                    <input value={form.guia} onChange={e => setForm(f => ({ ...f, guia: e.target.value }))} placeholder="Ej: 4500123456" />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Lote generado automáticamente</label>
                    <input readOnly value={lotePreview} placeholder="Selecciona tipo de producto..." />
                  </div>
                  <div className="form-group">
                    <label>Condición de recepción</label>
                    <select value={form.condicion} onChange={e => setForm(f => ({ ...f, condicion: e.target.value }))}>
                      <option value="ok">✓ Conforme</option>
                      <option value="obs">⚠ Con observaciones</option>
                      <option value="rej">✗ Rechazado</option>
                    </select>
                  </div>
                </div>
              </div>
              <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                <button className="btn btn-primary" onClick={registrar}>✓ Registrar recepción</button>
                <button className="btn btn-outline" onClick={() => {
                  if (!lotePreview) { showNotif('Selecciona tipo de producto primero'); return; }
                  const tipo = TIPOS.find(t => t.v === form.tipo);
                  setEtiqueta({ producto: (tipo?.l || 'Producto') + (form.desc ? ' ' + form.desc : ''), lote: lotePreview, qty: form.qty || '?', unidad: form.unidad, proveedor: form.proveedor || '—', vence: form.vence || '—', fecha: new Date().toISOString().slice(0, 10) });
                }}>🖨 Vista previa etiqueta</button>
                <button className="btn btn-ghost" onClick={() => { setForm({ tipo: '', desc: '', qty: '', unidad: 'kg', vence: '', proveedor: '', guia: '', condicion: 'ok' }); setLotePreview(''); }}>Limpiar</button>
              </div>
            </div>

            <div className="card">
              <div className="section-header">
                <div className="section-title">Recepciones del día</div>
                <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Buscar producto o lote..." style={{ width: 220 }} />
              </div>
              <div className="table-wrap">
                <table>
                  <thead><tr><th>Producto</th><th>Lote</th><th>Cantidad</th><th>Proveedor</th><th>Hora ingreso</th><th>Condición</th><th>Acciones</th></tr></thead>
                  <tbody>
                    {recepciones.length === 0
                      ? <tr><td colSpan="7" style={{ textAlign: 'center', color: 'var(--text3)', padding: 24 }}>Sin recepciones encontradas</td></tr>
                      : recepciones.map(r => (
                        <tr key={r.id}>
                          <td><strong>{r.producto}</strong></td>
                          <td><span className="lot-tag">{r.lote}</span></td>
                          <td>{r.qty} {r.unidad}</td>
                          <td>{r.proveedor}</td>
                          <td style={{ color: 'var(--text3)', fontSize: 12 }}>{r.fecha}</td>
                          <td>{condBadge(r.condicion)}</td>
                          <td><button className="btn btn-ghost btn-xs" onClick={() => setEtiqueta(r)}>🖨 Etiqueta</button></td>
                        </tr>
                      ))
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}

        {tab === 'sap' && (
          <div className="card">
            <div className="card-title"><div className="ct-icon">🔗</div> Órdenes de compra pendientes — SAP S/4HANA</div>
            <div className="table-wrap">
              <table>
                <thead><tr><th>N° OC SAP</th><th>Material</th><th>Qty</th><th>Proveedor</th><th>Fecha OC</th><th>Acción</th></tr></thead>
                <tbody>
                  {SAP_OCS.map(oc => (
                    <tr key={oc.oc}>
                      <td><span className="lot-tag">{oc.oc}</span></td>
                      <td><strong>{oc.material}</strong></td>
                      <td>{oc.qty} {oc.unidad}</td>
                      <td>{oc.proveedor}</td>
                      <td style={{ fontSize: 12, color: 'var(--text3)' }}>{oc.fecha}</td>
                      <td><button className="btn btn-ghost btn-xs" onClick={() => importarOC(oc)}>→ Recepcionar</button></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>

      <Modal open={!!etiqueta} onClose={() => setEtiqueta(null)} title="Etiqueta de lote — Vista previa">
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 18 }}>
          <LabelPreview rec={etiqueta} />
          <div style={{ display: 'flex', gap: 10 }}>
            <button className="btn btn-primary" onClick={() => window.print()}>🖨 Imprimir etiqueta</button>
            <button className="btn btn-ghost" onClick={() => setEtiqueta(null)}>Cerrar</button>
          </div>
          <p style={{ fontSize: 11, color: 'var(--text3)', textAlign: 'center', lineHeight: 1.6 }}>
            Compatible con Zebra y Brother · CODE128 · Escaneable con pistola lectora.
          </p>
        </div>
      </Modal>
    </>
  );
}
